import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SliderWrapper from 'jd-library/SliderWrapper';
import { showMessage } from 'jd-library/src/Toast/ToastAction';
import Button from "../../Button/Button";
import style from "./index.scss";
import { charFromWords, debounceFunc, updateCategoryMissingCardData } from './utils';
import { getProductData, setSelectedType, toggleCategoryMissingCardSlider, toggleCategoryMissingCardSliderPersist, updateEditProductDetail } from '../../../actions/products';
import NoProductFound from '../../no-product-found/NoProductFound';
import DontDealModel from './dontDealModel';
import PlusIcon from './plusIcon';
import NoCategoryIcon from './noCategoryIcon';
import { setNotificationData } from '../../../pages/listing/Notifications/redux/action';
import UblcsModal from '../../Ublcs-modal';
import { productCatCapitalize, updtLbl } from '../../../utills';

const CategoryMissing = () => {
    
    const dispatch = useDispatch();
    const { newProfile, profileObject, token } = useSelector(state => state.session);
    const categoryMissingCardData = useSelector(state => state.products.categoryMissingCardData);
    const getNotificationData = useSelector(state => state?.notifications?.counts);
    const isMobile = useSelector(state => state.library.deviceData.isMobile);
    const isReadOnly = useSelector(state => state.session.isReadOnly);
    
    const lbl = updtLbl(getNotificationData.nonexistingjdmartidcount, getNotificationData.nonexistingjdmartidcountLbl);
    
    const history = useHistory();
    const [scroll, setScroll] = useState(0);
    const [categoryDataAry, setCategoryDataAry] = useState(categoryMissingCardData || [])
    const [curCategoryObj, setCurCategoryObj] = useState({ name: "", jdmartid: "", isModelOpen: false })
    const session = useSelector(state => state.session);
    const [ublcsModal, toggleUblcsModal] = useState(false)
    
    useEffect(() => {
        setCategoryDataAry(categoryMissingCardData || [])
    }, [categoryMissingCardData])

    const ublcsModalHandler  = () => {
        toggleUblcsModal(true)
    }

    const addProdOrServ = (selectedProductType = "product") => {
        dispatch(setSelectedType({ selectedCategoryType: selectedProductType }));
        if (selectedProductType == 'product') {
            const editAry = [
                {
                    key: "productName",
                    value: "",
                },
                {
                    key: "imageUrlArr",
                    value: [],
                },
                {
                    key: "videoUrlArr",
                    value: [],
                },
                {
                    key: "videoUrlIds",
                    value: [],
                },
                {
                    key: "productId",
                    value: "ADD_PRODUCT",
                },
            ]
            dispatch(updateEditProductDetail(editAry));
        }
        if (isMobile) {
            dispatch(toggleCategoryMissingCardSlider(false));
            let queryParam = `?selectedProductType=${selectedProductType}`
            if (selectedProductType == 'product') {
                queryParam = "?isTemp=true"
                dispatch(getProductData({
                    productId: "ADD_PRODUCT",
                    isTemp: true
                }));
            }
            const route = "/products/add"
            const url = route + queryParam
            history.push(url);
        } else {
            const obj = {
                productId: 'ADD_PRODUCT'
            }
            if (selectedProductType == 'product') {
                obj.isTemp = true
            }
            dispatch(getProductData(obj))
        }
    }

    const removeCategory = async () => {
        const isLastProd = categoryDataAry.length == 1
        const { success, error } = await updateCategoryMissingCardData(curCategoryObj.jdmartid, isLastProd)
        let msg = `${curCategoryObj.name} Removed from Contract`;
        if (success) {
            dispatch(setNotificationData({ token: token }));
        }else{
            msg = error
        }
        dispatch(showMessage({
            showToastMessage: true,
            message: msg,
            type: 'info',
            duration: 2000
        }));
        setCurCategoryObj({ ...curCategoryObj, isModelOpen: false })
    }

    const scrollHandler = (e) => {
        if ((scroll < 10 && e.target.scrollTop > 10) || e.target.scrollTop == 0) {
            setScroll(e.target.scrollTop);
        }
    }

    const debouncedScrollHandler = debounceFunc(scrollHandler, 10);

    const leftIconAry = [
        {
            className: "icon-HDRback",
            onClick: () => {
                history.push("/products");
                dispatch(toggleCategoryMissingCardSlider(false));
                dispatch(toggleCategoryMissingCardSliderPersist(false));
            }
        }
    ]

    return (
        <>
            <SliderWrapper
                header={{
                    heading: `Add Missing ${lbl}`,
                    className: ` ${scroll > 10 ? "header-scrolled" : ""}`,
                    leftIcons: isMobile ? leftIconAry : []
                }}
                footer={{}}
                onHidden={async () => {
                    dispatch(toggleCategoryMissingCardSlider(false));
                    dispatch(toggleCategoryMissingCardSliderPersist(false));
                }}
                onScroll={debouncedScrollHandler}>
                <div className={"category-missing-container "+(session.hasGlassFooter ? 'ubl-pd85' : '')}>
                    {
                        categoryDataAry.length ?
                            categoryDataAry.map((item, ind) => {
                                const isProductService = item?.isProductService?.toLowerCase() || ""
                                const apiNodeType = isProductService == "product" || isProductService == "service" ? isProductService : "product"
                                const type = newProfile === 3 ? "service" : (newProfile === 0 || newProfile === 1) ? "product" : apiNodeType
                                const fakeText = charFromWords(item?.name)
                                return (
                                    <div className="category-item" key={`${ind}${item.jdmartid}`}>
                                        <div className="top-container">
                                            {
                                                item?.iconImage ?
                                                    <img className='imageClass' src={item.iconImage} alt={item?.jdmartid} />
                                                    : <div className='fakeImg'>{fakeText}</div>
                                            }
                                            <label className="labelClass">{productCatCapitalize(item.name) || ''}</label>
                                        </div>
                                        <div className="btn-container">
                                        <Button
                                            variant="primary"
                                            className={"btnClass addBtn"}
                                            disableRipple
                                            clickHandler={() => {
                                                if (isReadOnly) return ublcsModalHandler();
                                                addProdOrServ(type);}
                                            } 
                                        >
                                            <PlusIcon /> Add {type}
                                        </Button>
                                            {
                                                item.isDeleted ?
                                                    <Button
                                                    variant="text"
                                                    className={"btnClass delBtn"}
                                                    disableRipple
                                                    clickHandler={() => {
                                                        if (isReadOnly) return ublcsModalHandler();
                                                        setCurCategoryObj({ ...item, isModelOpen: true })
                                                    }}>
                                                    DON'T DEAL IN CATEGORY
                                                </Button>
                                                    : null
                                            }
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <NoProductFound
                                twoLineText={true}
                                labelOne={`Woohoo! ${profileObject.PluralLabelWithSpace} Added in`}
                                labelTwo={`All Categories`}
                                IconComp={NoCategoryIcon}
                            />
                    }
                </div>
            </SliderWrapper>
            {
                curCategoryObj.isModelOpen ?
                    <DontDealModel
                        title={curCategoryObj.name}
                        onHidden={() => setCurCategoryObj({ ...curCategoryObj, isModelOpen: false })}
                        removeCatBtn={removeCategory}
                        key={curCategoryObj.jdmartid}
                    />
                    : null
            }
            {ublcsModal ? 
                <UblcsModal 
                    onHidden= {() => toggleUblcsModal(false)
                }
            /> : null}
        </>
    )
}

export default CategoryMissing